<template>
	<v-dialog
		v-model="showDialog"
		max-width="1000px"
		persistent
		content-class="manage-field-dialog"
		scrollable
	>
		<v-card style="overflow-y: hidden">
			<v-card-title>Assign Permissions</v-card-title>
			<v-card-text
				class="pa-0 mt-6 pt-2"
				style="
					display: flex;
					flex-direction: column;
					overflow-x: hidden;
				"
			>
				<v-row class="px-2" no-gutters>
					<v-col cols="5">
						<v-select
							v-model="selectedProject"
							:items="userProjects"
							item-text="ProjectName"
							item-value="ProjectId"
							label="Projects"
							dense
						></v-select>
					</v-col>
				</v-row>
				<v-row class="px-2" no-gutters>
					<v-col cols="5"
						><v-select
							v-model="selectedPermissionGroup"
							:items="permissionGroups"
							item-text="Name"
							item-value="Id"
							label="Permission Groups"
							dense
						></v-select
					></v-col>
					<v-col cols="2"></v-col>
					<v-col cols="5"
						><v-select
							clearable
							v-model="selectedPermissionGroupAssigned"
							:items="permissionGroups"
							item-text="Name"
							item-value="Id"
							label="Permission Groups"
							dense
						></v-select
					></v-col>
				</v-row>
				<v-row class="pb-2 px-2" no-gutters>
					<v-col cols="5">
						<v-text-field
							v-model="searchUnassigned"
							append-icon="mdi-magnify"
							label="Search"
							single-line
							hide-details
							dense
					/></v-col>
					<v-col cols="2"></v-col>
					<v-col cols="5"
						><v-text-field
							v-model="searchAssigned"
							append-icon="mdi-magnify"
							label="Search"
							single-line
							hide-details
							dense
					/></v-col>
				</v-row>
				<div
					class="field-lists-container d-flex"
					style="flex-grow: 1; overflow-y: hidden"
				>
					<div class="col-5 hidden-list">
						<v-list dense>
							<v-subheader
								style="
									display: flex;
									justify-content: space-between;
								"
								>Unassigned Permissions
								<v-checkbox
									v-model="unasignedAllCheckBox"
									label="Select all"
									@click="selectAllUnassigned()"
								></v-checkbox>
							</v-subheader>
							<v-list-item-group
								v-if="
									selectedProject != null &&
									selectedPermissionGroup != null
								"
								v-model="selectedUnassigned"
								active-class="primary white--text"
								class="field-list"
								multiple
							>
								<v-list-item
									v-for="item in unassignedFiltered"
									:key="item.Id"
									:value="Object(item)"
								>
									<v-list-item-content>
										<v-list-item-title>{{
											item.PermissionName
										}}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</div>
					<div class="d-flex flex-column justify-center col-2">
						<v-btn
							class="my-2"
							color="primary"
							outlined
							text
							@click="assignPermission()"
						>
							<v-icon> mdi-arrow-right </v-icon>
						</v-btn>
						<v-btn
							class="my-2"
							color="primary"
							outlined
							text
							@click="unassignPermission()"
						>
							<v-icon> mdi-arrow-left </v-icon>
						</v-btn>
					</div>

					<div class="col-5 visible-list" v-if="!selectedProject">
						<v-subheader>Please select a project</v-subheader>
					</div>

					<div class="col-5 visible-list" v-if="selectedProject">
						<v-list dense>
							<v-subheader
								style="
									display: flex;
									justify-content: space-between;
								"
								>Assigned Permissions
								<v-checkbox
									v-model="assignedAllCheckBox"
									label="Select all"
									@click="sellectAllAssigned()"
								></v-checkbox
							></v-subheader>

							<v-list-item-group
								v-model="selectedAssigned"
								active-class="primary white--text"
								class="field-list"
								multiple
							>
								<v-list-item
									v-for="item in assignedFiltered"
									:key="item.Id"
									:value="Object(item)"
									class="px-1"
								>
									<v-list-item-content>
										<v-list-item-title>
											{{ item.PermissionName }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</div>
				</div>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click="onCancel()"> Done </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { UserProjectPermissionGetters } from '../../../store/getters';
import {
	GeneralActions,
	UserProjectPermissionActions,
} from '../../../store/actions';
import { mapGetters } from 'vuex';
export default {
	name: 'UserProjectPermissionAssignment',
	props: {
		showDialog: Boolean,
	},
	computed: {
		...mapGetters({
			userProjects: [UserProjectPermissionGetters.USERPROJECTS],
			permissionGroups: [UserProjectPermissionGetters.PERMISSIONGROUPS],
			unassignedPermissions: [
				UserProjectPermissionGetters.UNASSIGNEDPERMISSIONS,
			],
			assignedPermissions: [
				UserProjectPermissionGetters.ASSIGNEDPERMISSIONS,
			],
		}),
		assignedFiltered() {
			let result = [];
			let adminGroupId = this.permissionGroups.find(
				(x) => x.Name === 'Admin'
			).Id;
			if (this.selectedProject) {
				if (this.selectedPermissionGroupAssigned) {
					this.assignedPermissions.forEach((p) => {
						if (
							p.PermissionGroupId ==
							this.selectedPermissionGroupAssigned
						)
							result.push(p);
					});
					if (!this.searchAssigned) {
						return result.sort((a, b) =>
							a.PermissionName > b.PermissionName ? 1 : -1
						);
					}
					return result
						.sort((a, b) =>
							a.PermissionName > b.PermissionName ? 1 : -1
						)
						.filter(
							(x) =>
								x.PermissionName &&
								x.PermissionName.toLowerCase().includes(
									this.searchAssigned.toLowerCase()
								)
						);
				} else {
					this.assignedPermissions.forEach((p) => result.push(p));
					if (!this.selectedPermissionGroupAssigned) {
						result = this.assignedPermissions.filter(
							(p) => p.PermissionGroupId == adminGroupId
						);
					}
					if (this.searchAssigned == '') {
						return result.sort((a, b) =>
							a.PermissionName > b.PermissionName ? 1 : -1
						);
					}
					return result
						.sort((a, b) =>
							a.PermissionName > b.PermissionName ? 1 : -1
						)
						.filter(
							(x) =>
								x.PermissionName &&
								x.PermissionName.toLowerCase().includes(
									this.searchAssigned.toLowerCase()
								)
						);
				}
			} else return [];
		},
		unassignedFiltered() {
			let result = [];
			if (this.selectedPermissionGroup) {
				this.unassignedPermissions.forEach((p) => {
					if (p.PermissionGroupId == this.selectedPermissionGroup)
						result.push(p);
				});
				if (!this.searchUnassigned)
					return result.sort((a, b) =>
						a.PermissionName > b.PermissionName ? 1 : -1
					);
				return result
					.sort((a, b) =>
						a.PermissionName > b.PermissionName ? 1 : -1
					)
					.filter(
						(x) =>
							x.PermissionName &&
							x.PermissionName.toLowerCase().includes(
								this.searchUnassigned.toLowerCase()
							)
					);
			} else {
				this.unassignedPermissions.forEach((p) => result.push(p));
				if (this.searchUnassigned == '')
					return result.sort((a, b) =>
						a.PermissionName > b.PermissionName ? 1 : -1
					);
				return result
					.sort((a, b) =>
						a.PermissionName > b.PermissionName ? 1 : -1
					)
					.filter(
						(x) =>
							x.PermissionName &&
							x.PermissionName.toLowerCase().includes(
								this.searchUnassigned.toLowerCase()
							)
					);
			}
		},
	},
	data() {
		return {
			unasignedAllCheckBox: false,
			assignedAllCheckBox: false,
			selectedProject: null,
			selectedPermissionGroup: null,
			selectedPermissionGroupAssigned: null,
			selectedUnassigned: [],
			selectedAssigned: [],
			searchAssigned: '',
			searchUnassigned: '',
		};
	},
	mounted() {
		this.loadData();
	},
	watch: {
		selectedProject() {
			this.loadData();
		},
		selectedPermissionGroup() {
			this.unasignedAllCheckBox = false;
			this.selectedUnassigned = [];
		},
		selectedAssigned() {
			if (
				this.assignedFiltered.length == this.selectedAssigned.length &&
				this.assignedFiltered.length != 0
			)
				this.assignedAllCheckBox = true;
			else this.assignedAllCheckBox = false;
		},
		selectedUnassigned() {
			if (
				this.unassignedFiltered.length ==
					this.selectedUnassigned.length &&
				this.unassignedFiltered.length != 0
			)
				this.unasignedAllCheckBox = true;
			else this.unasignedAllCheckBox = false;
		},
	},

	methods: {
		selectAllUnassigned() {
			if (this.unasignedAllCheckBox == true) {
				this.selectedUnassigned = [];
				this.unassignedFiltered.forEach((permission) => {
					this.selectedUnassigned.push(permission);
				});
			} else {
				this.selectedUnassigned = [];
			}
		},
		sellectAllAssigned() {
			if (this.assignedAllCheckBox == true) {
				this.selectedAssigned = [];
				this.assignedFiltered.forEach((permission) => {
					this.selectedAssigned.push(permission);
				});
			} else {
				this.selectedAssigned = [];
			}
		},
		onCancel() {
			this.$emit('cancel');
			this.selectedProject = null;
			this.selectedPermissionGroup = null;
			this.selectedPermissionGroupAssigned = null;
		},
		loadData() {
			this.$store
				.dispatch(UserProjectPermissionActions.LOAD, {
					userId: this.$route.params.id,
					projectId: this.selectedProject,
				})
				.then(() => {
					this.unasignedAllCheckBox = false;
					this.assignedAllCheckBox = false;
					(this.selectedUnassigned = []),
						(this.selectedAssigned = []);
				});
		},
		assignPermission() {
			this.$store.dispatch(GeneralActions.LOADING, true);
			this.$store
				.dispatch(
					UserProjectPermissionActions.INSERT_USERPROJECTPERMISSION,
					{
						userId: this.$route.params.id,
						projectId: this.selectedProject,
						permissions: this.selectedUnassigned,
					}
				)
				.then(() => {
					this.loadData();
				});
		},
		unassignPermission() {
			this.$store.dispatch(GeneralActions.LOADING, true);
			this.$store
				.dispatch(
					UserProjectPermissionActions.DELETE_USERPROJECTPERMISSION,
					{
						userId: this.$route.params.id,
						projectId: this.selectedProject,
						permissions: this.selectedAssigned,
					}
				)
				.then(() => {
					this.loadData();
				});
		},
	},
};
</script>
